import { useState } from "react";
import axios from "axios";
import { CheckCircle2, Loader2, Send } from "lucide-react";
import { API } from "../../config";
import { trackEvent } from "../../hooks/useBehaviorTracker";

const Field = ({ label, testid, ...p }) => (
  <label className="block">
    <span className="text-xs text-white/60">{label}</span>
    <input {...p} className="mt-1 w-full px-3 py-2.5 rounded-lg bg-white text-gray-900 placeholder-gray-400 outline-none border-2 border-transparent focus:border-[#a3e635]" data-testid={testid} />
  </label>
);

export const WebInquiryForm = ({ f, ui }) => {
  const [v, setV] = useState({ name: "", email: "", phone: "", company: "", current_url: "", message: "" });
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setV({ ...v, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (!consent || v.name.trim().length < 2 || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v.email.trim())) { setState("error"); return; }
    setState("busy");
    try {
      await axios.post(`${API}/web-design/inquiry`, { ...v, funnel: f.slug, lang: f.lang, consent, ref: localStorage.getItem("web_ref") || "" });
      trackEvent("order_click", { funnel: f.slug, type: "web_inquiry" });
      setState("sent");
    } catch { setState("error"); }
  };
  if (state === "sent") return <p className="rounded-2xl border border-[#a3e635]/40 bg-[#a3e635]/10 p-6 text-[#d9f99d] flex gap-2" data-testid="web-inquiry-sent"><CheckCircle2 className="w-5 h-5 shrink-0" />{ui.sent}</p>;
  return (
    <form noValidate onSubmit={submit} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 space-y-3" data-testid="web-inquiry-form">
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label={`${ui.name} *`} value={v.name} onChange={set("name")} testid="web-inquiry-name" />
        <Field label={`${ui.email} *`} type="email" value={v.email} onChange={set("email")} testid="web-inquiry-email" />
        <Field label={ui.phone} value={v.phone} onChange={set("phone")} testid="web-inquiry-phone" />
        <Field label={ui.company} value={v.company} onChange={set("company")} testid="web-inquiry-company" />
      </div>
      <Field label={ui.current} value={v.current_url} onChange={set("current_url")} placeholder="www…" testid="web-inquiry-current-url" />
      <label className="block">
        <span className="text-xs text-white/60">{ui.message}</span>
        <textarea rows={3} value={v.message} onChange={set("message")} className="mt-1 w-full px-3 py-2.5 rounded-lg bg-white text-gray-900 outline-none border-2 border-transparent focus:border-[#a3e635]" data-testid="web-inquiry-message" />
      </label>
      <label className="flex items-start gap-2 text-xs text-white/60 cursor-pointer">
        <input type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} className="mt-0.5 w-4 h-4 accent-[#a3e635]" data-testid="web-inquiry-consent" />
        <span>{ui.consent}</span>
      </label>
      {state === "error" && <p className="text-sm text-red-300" data-testid="web-inquiry-error">{ui.err}</p>}
      <button type="submit" disabled={state === "busy"} className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-[#a3e635] text-black font-black hover:bg-[#bef264] active:scale-[.98] transition-[background-color,transform]" data-testid="web-inquiry-submit">
        {state === "busy" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}{state === "busy" ? ui.sending : ui.send}
      </button>
    </form>
  );
};
